<template>
  <tr>
    <td v-if="!hidePayer">
      <a
        :href="payerLink"
        v-text="payer.attributes.full_name"
      />
    </td>
    <td v-text="chargeable.attributes.title" />
    <td
      v-if="!refund"
      v-text="payment.attributes.amount"
    />
    <td v-else>
      <i
        style="text-decoration: line-through"
        v-text="payment.attributes.amount"
      /> Refunded
    </td>
    <td v-text="createdAt" />
    <td class="text-center">
      <button
        class="icon"
        rel="noopener noreferrer"
        @click.prevent="invoicePdf"
      >
        <SimpleSVG
          filepath="/svg/download.svg"
          height="25"
          width="24"
        />
      </button>
    </td>
    <td class="capitalize">
      <span
        :class="payment.attributes.status === 'paid' ? 'text-green' : ''"
        v-text="payment.attributes.status"
      />
    </td>
    <td v-text="nextPaymentDueDate" />
    <td v-can="'manage-refunds'">
      <span
        v-if="refund"
        v-text="`${refund.attributes.status}`"
      />
      <div v-else-if="payment.attributes.status === 'paid'">
        <button
          type="button"
          class="btn btn--sm mt-1"
          @click.prevent="showCreateRefundModal = true"
          v-text="'Refund Payment'"
        />
        <CreateRefundModal
          :show="showCreateRefundModal"
          :payment="payment"
          @close="showCreateRefundModal = false"
          @refundCreated="refreshPayment"
        />
      </div>
      <span
        v-else
        v-text="'-'"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'
import { SimpleSVG } from 'vue-simple-svg'
import CreateRefundModal from './_modals/CreateRefundModal'

export default {
  name: 'PaymentRow',
  components: {
    CreateRefundModal,
    SimpleSVG,
  },
  props: {
    payment: {
      type: Object,
      required: true,
    },
    hidePayer: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      showCreateRefundModal: false,
    }
  },
  computed: {
    createdAt() {
      return this.$date.toMomentDateFormat(this.payment.attributes.created_at * 1000)
    },

    payer() {
      return this.payment.payer
    },
    payerLink() {
      return this.payer ? this.$urlGenerator.active(`members/${this.payer.uuid}`) : ''
    },
    refund() {
      return this.payment.hasOwnProperty('refund') ? this.payment.refund : null
    },
    chargeable() {
      return this.payment.chargeable
    },
    nextPaymentDueDate() {
      return this.payer.subscription.hasOwnProperty('attributes')
        ? this.$date.toMomentDateFormat(this.payer.subscription.attributes.current_period_end * 1000)
        : ''
    },
  },
  methods: {
    ...mapActions([
      'getPaymentInvoicePdfLink',
    ]),
    refreshPayment() {
      this.$emit('refreshPayments')
    },
    async invoicePdf() {
      const url = await this.getPaymentInvoicePdfLink(this.payment.uuid)

      window.open(url, '_blank')
    },
  },
}
</script>
